<template>
  <div class="page-push-add">

    <my-header></my-header>

    <div class="content-container-level-1">
      <h2>New Push Notification</h2>

      <!--
      <h3>Ограничения</h3>
      <p class="mb-3">
        Если нужно отправить уведомление всем игрокам,
        то&nbsp;не&nbsp;заполняйте поля в&nbsp;данном разделе (в разделе "Ограничения").
      </p>
      <p class="mb-3">
        Если нужно отправить уведомление не всем игрокам,
        а только некоторым,
        то&nbsp;заполните требуемые поля в&nbsp;данном разделе.
      </p>
      -->

      <form @submit.prevent="schedulePush">
        <div class="form-group">
          <label for="max-version">Max version (exclusive)</label>
          <input v-model="maxVersionStr" id="max-version" ref="maxVersionInput" class="form-control">
        </div>

        <div class="form-group">
          <h5>Limit to platforms</h5>
          <div
            v-for="platform in platforms"
            :key="platform"
            class="form-check"
          >
            <input class="form-check-input" type="checkbox" :id="'patform_'+platform" :value="platform" v-model="selectedPlatforms">
            <label class="form-check-label" :for="'patform_'+platform">{{platform | getPlatformName}}</label>
          </div>
        </div>

        <div class="form-group">
          <label for="player-ids">Player ids (delimitered with ,)</label>
          <b-icon icon="question-circle" v-b-popover.hover.right="'To send push-notification to specific players only, specify their ids.'"></b-icon>
          <input v-model="playersIdsStr" id="player-ids" class="form-control">
        </div>

        <hr>

        <div>
          <h3 class="mb-3">Start</h3>

          <b-form-datepicker
            v-model="plannedStartDate"
            :min="minPlannedStartDate"
            :start-weekday="MONDAY"
            class="mb-2"
          />

          <time-input
            v-model="plannedStartTime"
          />
        </div>

        <hr>

        <h3 class="mb-3">
          Image url
        </h3>

        <div class="form-group">
          <label for="player-ids"><i>(root is {{imageUrlRoot}})</i></label>
          <b-icon icon="question-circle" v-b-popover.hover.right="'To add an image, specify its name, otherwise the default will be used'"></b-icon>
          <input
              v-model="imageUrl"
              id="imageUrl"
              class="form-control"
              placeholder="Enter image url like 'common.jpg'" >
        </div>

        <h3 class="mb-3">Text variants</h3>

        <text-variant-input
          v-for="textVariant in textVariants"
          :key="textVariant.lang"
          :textVariant="textVariant"
          ref="textVariantInput"
          class="mb-3"
        />

        <hr>

        <b-form-checkbox
          id="checkbox-for-test"
          v-model="forTest"
          class="mb-3"
        >
          For test
        </b-form-checkbox>

        <hr>

        <b-button :to="{name: 'pushes'}">Cancel</b-button>

        <delayed-action-button
          type="submit"
          variant="primary"
          :enabled="canInteract"
          :running="scheduling"
          idleLabel="Schedule"
          runningLabel="Scheduling"
        />

      </form>
    </div>

  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import { createEmptyTextVariants  } from '../model/push.js';
import { createTextVariants } from '../model/push.js';

import MyHeader from './Header.vue';
import TextVariantInput from './PushTextVariantInput.vue';
import DelayedActionButton from './DelayedActionButton.vue';

import TimeInput from './TimeInput.vue';

import { getPlatforms                        } from '../util.js';
import { convertMomentToDataStr              } from '../util.js';
import { convertMomentToTimeStr              } from '../util.js';
import { convertDataStrAndTimeStrToLocalData } from '../util.js';
import { getSortedNumbers                    } from '../util.js';
import { parseOptionalVersionInput           } from '../util.js';
import { convertVersionToVersionStr          } from '../util.js';

import { parseUniquePlayersIdsDelimitedByComma } from '../model/player.js';

export default {
  name: 'PushAdd',

  components: {
    MyHeader,
    TextVariantInput,
    TimeInput,
    DelayedActionButton,
  },

  data() {
    const textVariants = createEmptyTextVariants();

    const start = new Date();
    const startDateStr = convertMomentToDataStr(start);
    const startTimeStr = convertMomentToTimeStr(start);

    return {
      MONDAY: 1,

      imageUrlRoot: "/assets/notifications/",
      imageUrl: "common.jpg",

      maxVersionStr: '',
      selectedPlatforms: [],
      playersIdsStr: '',

      textVariants,

      plannedStartDate:    startDateStr,
      minPlannedStartDate: startDateStr,
      plannedStartTime:    startTimeStr,
      forTest: false,

      scheduling: false,
    };
  },

  computed: {
    platforms() {
      return getPlatforms();
    },

    plannedStartMoment() {
      return convertDataStrAndTimeStrToLocalData(this.plannedStartDate, this.plannedStartTime);
    },

    plannedStartSec() {
      return Math.floor(this.plannedStartMoment.getTime() / 1000);
    },

    canInteract() {
      return !this.scheduling;
    },
  },

  methods: {
    schedulePush() {
      if(this.scheduling) {
        return;
      }
  
      notifier.deleteSenderNotifications(this);

      const maxVersionParsingReport = parseOptionalVersionInput(this.maxVersionStr);
      if(maxVersionParsingReport.error !== null) {
        this.$refs.maxVersionInput.focus();
        const message = 'Can not parse max version. ' + maxVersionParsingReport.error.message;
        notifier.showError(message, {sender: this});
        return;
      }

      const playersIdsResult = parseUniquePlayersIdsDelimitedByComma(this.playersIdsStr);
      if(playersIdsResult.error !== null) {
        notifier.showError(playersIdsResult.error, {sender: this});
        return;
      }

      this.scheduling = true;

      const pushInfo = {
        stime:        this.plannedStartSec,
        textVariants: this.getTextVariants(),
      };

      const maxVersion = maxVersionParsingReport.version;
      if(maxVersion !== null) {
        pushInfo.maxVersion = convertVersionToVersionStr(maxVersion);
      }

      if(this.selectedPlatforms.length > 0) {
        const sortedSelectedPlatforms = getSortedNumbers(this.selectedPlatforms);
        pushInfo.platforms = sortedSelectedPlatforms;
      }

      const playersIds = playersIdsResult.playersIds;
      if(playersIds !== null && playersIds.length > 0) {
        pushInfo.playersIds = getSortedNumbers(playersIds);
      }

      if(this.forTest) {
        pushInfo.forTest = true;
      }

      if (this.imageUrl === "") {
        this.imageUrl = "common.jpg"
      }

      pushInfo.imageUrl = this.imageUrlRoot + this.imageUrl

      const url = '/push/add';
      HTTP.post(url, pushInfo)
      .then(() => {
        notifier.showSuccessAfterTransition('Push added.');
        this.$router.push({name: 'pushes'});
      })
      .catch(err => {
        this.scheduling = false;
        notifier.showError(err, {sender: this});
      });
    },

    getTextVariants() {
      const textVariantInputs = this.$refs.textVariantInput;
      return createTextVariants(textVariantInputs);
    },
  }
}
</script>

<style scoped>
.page-push-add {
  margin-bottom: 2rem;
}
</style>
